module.exports = __webpack_public_path__ + "media/images/categories/icon_cat5-9d27320b6ad28feed2077f9f0c1912b9.svg";